import moment from 'moment'
import { unparse } from 'papaparse'

export const exportCSVFile = (data: any, from: string) => {
    let processedData
    if (from.includes('history')) {
        processedData = flattenflattenHistoryData(data)
    } else {
        processedData = flattenDocumentData(data)
    }

    const csv = unparse(processedData)
    downloadCSVFile(csv, from)
}

//@ts-ignore
export const downloadCSVFile = (csv: Blob | string, from = 'download') => {

    //@ts-ignore
    const blob = new Blob(['\uFEFF'+csv], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')

    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `${from}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const flattenflattenHistoryData = (data: any) => {
    return data.map((item: any) => ({
        ...item,
        createdBy: `${item.createdBy?.id} ${item.createdBy?.firstName} ${item.createdBy?.lastName} ${item.createdBy?.email}`,
        action: toTitleCase(item.action),
        data: formatData(item.action, item.data),
        createdDate: moment(item.createdDate).format('MM/DD/YYYY HH:mm:ss')
    }))
}

const flattenDocumentData: any = (data: any) => {
    return data.map((item: any) => ({
        ...mapProperties(item),
        meta: convertObjectsToArrays(item.meta)
    }))
}

const mapProperties = (item: any) => ({
    'Document_Id': item.id,
    'Archived?': item.isArchived,
    'Agency_Id': item.departmentId,
    'Document_Template_Id': item.documentSchemaId,
    'Files': item.media,
    'Created_Date': item.createdDate,
    'Last_Updated_Date': item.updatedDate,
    'Document_Data': convertObjectsToArrays(item.data)
})

export const convertObjectsToArrays: any = (data: any) => {
    if (Array.isArray(data)) {
        return data.map(convertObjectsToArrays)
    } else if (typeof data === 'object' && data !== null) {
        return Object.values(data).map(convertObjectsToArrays)
    } else {
        return data
    }
}

const toTitleCase = (action: string) => {
    const words = action.split('_')
    let result = ''
    for (let i = 0; i < words.length; i++) {
        result += words[i][0].toUpperCase() + words[i].slice(1).toLowerCase() + ' '
    }
    return result.trim()
}

const formatData = (action: string, data: any) => {
    const arrayData = data
    switch (action) {
        case 'member_added':
            return `${arrayData.firstName} ${arrayData.lastName} was added to the agency`

        case 'member_role_added':
            return `${arrayData.firstName} ${arrayData.lastName} was given the ${arrayData.role} role`

        case 'member_role_removed':
            return `${arrayData.firstName} ${arrayData.lastName} role as ${arrayData.role} was removed`

        case 'member_removed':
            return `${arrayData.firstName} ${arrayData.lastName} was removed from the agency`

        case 'member_details_updated':
            return `${arrayData.firstName} ${arrayData.lastName}'s profile was updated`

        case 'member_verified':
            return `${arrayData.firstName} ${arrayData.lastName} was verified ${
                arrayData?.subAction === 'verification_code'
                    ? 'by using the agency access code'
                    : ''
            }`

        case 'member_unverified':
            return `${arrayData.firstName} ${arrayData.lastName} was unverified`

        case 'room_created':
            return `Room ${arrayData.name} was created`

        case 'department_invite_consumed': {
            const invite = arrayData?.invite ?? {}
            return `${invite.to} User ID: ${arrayData.blueUserId} accepted an agency invite using ${invite.token ?? 'an invite token'}`
        }

        case 'room_invite_consumed':
            if (!arrayData.invite)
                return 'User accepted invite to the room using an invite token'
            return `${
                arrayData.invite.to || 'A user'
            } accepted a room invite using token ${arrayData.invite.token}`

        case 'room_join_request_accepted_by_rules': {
            const acceptedByRulesUserId = arrayData.roomJoinRequest?.requestedById || arrayData.requestedById
            if (!acceptedByRulesUserId) return 'Room join request was automatically accepted by rules'
            return (
                `Room join request from User ID: ${acceptedByRulesUserId} was automatically accepted by rules for room ${arrayData.name} (${arrayData.roomId})`
            )
        }

        case 'room_join_request_accepted': {
            const acceptedUserId = arrayData.roomJoinRequest?.requestedById || arrayData.requestedById
            if (!acceptedUserId) return 'Room join request was accepted'
            return `Room join request from User ID: ${acceptedUserId} was accepted for room ${arrayData.name} (${arrayData.roomId})`
        }

        case 'room_join_request_rejected': {
            const rejectedUserId = arrayData.roomJoinRequest?.requestedById || arrayData.requestedById
            if (!rejectedUserId) return 'Room join request was rejected'
            return `Room join request from User ID: ${rejectedUserId} was rejected for room ${arrayData.name} (${arrayData.roomId})`
        }

        case 'room_join_request_blocked': {
            const blockedUserId = arrayData.roomJoinRequest?.requestedById || arrayData.requestedById
            if (!blockedUserId) return 'Room join request was blocked'
            return `Room join request from User ID: ${blockedUserId} was blocked for room ${arrayData.name} (${arrayData.roomId})`
        }

        case 'room_member_added':
            return `${arrayData.firstName} ${arrayData.lastName} was added to room ${arrayData.name} (${arrayData.roomId}) as member`

        case 'room_manager_added':
            return `${arrayData.firstName} ${arrayData.lastName} was added to room ${arrayData.name} (${arrayData.roomId}) as manager`

        case 'room_member_removed':
            return `${arrayData.firstName} ${arrayData.lastName} was removed from room ${arrayData.name} (${arrayData.roomId})`

        case 'room_manager_removed':
            return `${arrayData.firstName} ${arrayData.lastName} was removed from room ${arrayData.name} (${arrayData.roomId})`

        case 'department_invite_sent':
            return `Sent an agency invite to: ${arrayData.invites
                .map((i: any) => i.to)
                .toString()}`

        case 'room_invite_sent':
            return `Sent an invite to the room ${
                arrayData.name
            } to: ${arrayData.invites.map((i: any) => i.to).toString()}`

        case 'room_export_run':
            return `A room export was run: ${arrayData.description} (id: ${arrayData.auditId})`

        case 'audit_run':
            return `A message audit was run (id: ${arrayData.auditId})`

        case 'audit_download':
            return `An audit was downloaded (id: ${arrayData.auditId})`

        case 'media_download': {
            const { origin, fileName, documentName, documentId, roomName, roomId } = arrayData

            if (!origin) {
                return `Media was downloaded`
            }

            const isDocument = origin === 'document'
            const sourceType = isDocument ? 'Document' : 'Room'

            if (isDocument) {
                return `${sourceType} Download: ${fileName} from "${documentName}" (ID#${documentId})`
            } else {
                return `${sourceType} Download: ${fileName} from #${roomName} (ID#${roomId})`
            }
        }

        case 'document_added': {
            const { documentName = '', documentId } = arrayData

            return `Document ${documentName} was added (ID#${documentId})`
        }

        case 'document_cloned': {
            const { documentName = '', from, to } = arrayData

            return `Document ${documentName} was cloned from (ID#: ${from}) to (ID#: ${to})`
        }

        case 'document_downloaded_pdf': {
            const {documentName, documentId } = arrayData

            return `Downloaded PDF document ${documentName} (ID#${documentId})`
        }

        case 'document_downloaded_csv': {
            const {documentName, documentId } = arrayData

            return `Downloaded CSV document ${documentName} (ID#${documentId})`
        }

        case 'document_deleted': {
            const {documentName, documentId } = arrayData

            return `Deleted document ${documentName} (ID#${documentId})`
        }

        case 'updated': {
            const keys = arrayData.changeSet ? Object.keys(arrayData.changeSet) : []
            return `Changed: ${keys.join(', ')}`
        }

        case 'connector_created': {
            const connectorName = arrayData.integrationName || arrayData.name
            return `Created connector ${connectorName}`
        }

        case 'connector_disabled': {
            const connectorName = arrayData.integrationName || arrayData.name
            const parts = [`Disabled connector ${connectorName}`]
            if (arrayData.revokedApiKeysCount > 0 || arrayData.deletedAclCount > 0) {
                parts.push(`(revoked ${arrayData.revokedApiKeysCount} API key(s), removed ${arrayData.deletedAclCount} permission(s))`)
            }
            return parts.join(' ')
        }

        case 'connector_deleted': {
            const hardDeletedName = arrayData.integrationName || arrayData.name
            const hardParts = [`Permanently deleted connector ${hardDeletedName}`]
            if (arrayData.deletedApiKeysCount > 0 || arrayData.deletedAclCount > 0) {
                hardParts.push(`(removed ${arrayData.deletedApiKeysCount} API key(s), ${arrayData.deletedAclCount} permission(s))`)
            }
            return hardParts.join(' ')
        }

        case 'connector_updated': {
            const iConnectorName = arrayData.integrationName || arrayData.name
            const iKeys = arrayData.changeSet ? Object.keys(arrayData.changeSet) : []
            return `Updated connector ${iConnectorName}: changed ${iKeys.join(', ')}`
        }

        case 'connector_api_key_created':
            return `Created API key "${arrayData.apiKeyName}" (ending in ${arrayData.keyEnding}) for connector ${arrayData.integrationName}`

        case 'connector_api_key_revoked':
            return `Revoked API key "${arrayData.apiKeyName}" (ending in ${arrayData.keyEnding}) for connector ${arrayData.integrationName}`

        case 'connector_acl_created': {
            const target = arrayData.principalType === 'Room' && arrayData.roomName
                ? `room ${arrayData.roomName}`
                : arrayData.principalType
            return `Granted ${arrayData.accessType} access to connector ${arrayData.integrationName} for ${target}`
        }

        case 'connector_acl_updated': {
            const aclKeys = arrayData.changeSet ? Object.keys(arrayData.changeSet) : []
            return `Updated access for connector ${arrayData.integrationName}: changed ${aclKeys.join(', ')}`
        }

        case 'connector_acl_deleted': {
            const aclTarget = arrayData.principalType === 'Room' && arrayData.roomName
                ? `room ${arrayData.roomName}`
                : arrayData.principalType
            return `Removed ${arrayData.accessType} access from connector ${arrayData.integrationName} for ${aclTarget}`
        }

        case 'connector_room_acl_enabled':
            return `Enabled connector ${arrayData.integrationName} in room ${arrayData.roomName} (${arrayData.created} permission(s) added)`

        case 'connector_room_acl_disabled':
            return `Disabled connector ${arrayData.integrationName} in room ${arrayData.roomName} (${arrayData.deleted} permission(s) removed)`

        case 'agreement_created':
            return `Created agreement ${arrayData.agreementName}`

        case 'agreement_content_updated':
            return `Edited agreement content of ${arrayData.agreementName} (v${arrayData.version})`

        case 'agreement_settings_updated': {
            const agreementKeys = arrayData.changeSet ? Object.keys(arrayData.changeSet) : []
            // Elevate an enabled/disabled flip into the text, mirroring the web log.
            const enabledChange = arrayData.changeSet?.enabled
            const statusPrefix = enabledChange ? `${enabledChange.to ? 'Enabled' : 'Disabled'}: ` : ''
            return `${statusPrefix}Updated settings of ${arrayData.agreementName}: changed ${agreementKeys.join(', ')}`
        }

    }

    return undefined
}
